module.exports = __webpack_public_path__ + "img/ePRO.d660cc01.png";